module.exports = __webpack_public_path__ + "static/img/detail-friendW.977f0010.png";